import React from "react";
import emojis from "../emoji.json";
import "../blocks/Hero.css";

const HeroComponent = () => {
  const getRandomEmoji = () => {
    const randomIndex = Math.floor(Math.random() * emojis.length);
    return emojis[randomIndex].emoji;
  };

  return (
    <div id="home" className="hero-image-container">
      <div className="gradient-overlay"></div>
      <div className="hero-text">
        <h1>Carmen Supermarket</h1>
        <h2>Pop-Rock desde Mallorca {getRandomEmoji()}</h2>
        <div className="hero-actions">
          <a
            className="hero-actions__link hero-actions__link--primary"
            href="#contact"
          >
            Contacto
          </a>
          <a
            className="hero-actions__link hero-actions__link--secondary"
            href="#shows"
          >
            Ver directos
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroComponent;
